import React from 'react';
import './Topbar.css'
import { Link, withRouter } from 'react-router-dom';

import shephaTitleLogo from '../../assets/shephaTitleLogo.png'

const topbar = (props) => {

    return (
        <div className="topbar">
            <div className="right-layout">
                <Link to="/"><img className="logo" src={shephaTitleLogo} alt="Shepha" /></Link>
            </div>
            <div className="left-layout">
                
            </div>

        </div>
    );
}

export default withRouter(topbar);